/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0 and the Server Side Public License, v 1; you may not use this file except
 * in compliance with, at your election, the Elastic License 2.0 or the Server
 * Side Public License, v 1.
 */

import React, { createContext, Context } from 'react';
import PropTypes from "prop-types";
var I18nContext = /*#__PURE__*/createContext({});
var EuiI18nProvider = I18nContext.Provider,
  EuiI18nConsumer = I18nContext.Consumer;
var EuiContext = ({
  i18n = {},
  children
}) => <EuiI18nProvider value={i18n}>{children}</EuiI18nProvider>;
EuiContext.propTypes = {
  i18n: PropTypes.shape({
    mapping: PropTypes.shape({}),
    mappingFunc: PropTypes.func,
    /**
       * Some browsers' translation features don't work with a rendered `<Fragment>` component.
       * The `render` function allows you to pass in another component instead, e.g. `<div>`
       */
    render: PropTypes.func,
    formatNumber: PropTypes.func,
    formatDateTime: PropTypes.func,
    locale: PropTypes.string
  }).isRequired,
  /**
     * ReactNode to render as this component's content
     */
  children: PropTypes.node.isRequired
};
export { EuiContext, EuiI18nConsumer, I18nContext };
try {
  EuiContext.__docgenInfo = {
    tags: {},
    filePath: '/app/packages/eui/src/components/context/context.tsx',
    description: '',
    displayName: 'EuiContext',
    methods: [],
    props: {
      i18n: {
        defaultValue: {
          value: '{}'
        },
        description: '',
        name: 'i18n',
        parent: {
          fileName: 'eui/src/components/context/context.tsx',
          name: 'EuiContextProps'
        },
        declarations: [{
          fileName: 'eui/src/components/context/context.tsx',
          name: 'EuiContextProps'
        }],
        required: false,
        type: {
          name: 'I18nShape'
        }
      },
      children: {
        defaultValue: null,
        description: "ReactNode to render as this component's content",
        name: 'children',
        parent: {
          fileName: 'eui/src/components/context/context.tsx',
          name: 'EuiContextProps'
        },
        declarations: [{
          fileName: 'eui/src/components/context/context.tsx',
          name: 'EuiContextProps'
        }],
        required: true,
        type: {
          name: 'ReactNode'
        }
      }
    },
    extendedInterfaces: ['EuiContextProps']
  };
} catch (e) {}
try {
  Context.__docgenInfo = {
    tags: {
      see: '{@link https ://react.dev/learn/passing-data-deeply-with-context React Docs}\n' + '{@link https ://react-typescript-cheatsheet.netlify.app/docs/basic/getting-started/context/ React TypeScript Cheatsheet}',
      example: '```tsx\n' + "import { createContext } from 'react';\n" + '\n' + "const ThemeContext = createContext('light');\n" + '```'
    },
    filePath: '/app/packages/eui/src/components/context/context.tsx',
    description: 'Context lets components pass information deep down without explicitly\n' + 'passing props.\n' + '\n' + 'Created from {@link createContext}',
    displayName: 'Context',
    methods: [],
    props: {},
    extendedInterfaces: ['EuiContextProps']
  };
} catch (e) {}